import { Stack } from "@mui/material"
import { type FC, forwardRef } from "react"

import { Modal } from "../modal"
import type { ConfirmProps } from "./confirm.types"
import { Footer } from "./footer"
import { Text } from "./text"

export const Confirm: FC<ConfirmProps> = forwardRef(
	(
		{
			open,
			title,
			subtitle,
			onClose,
			cancelText,
			confirmText,
			onConfirm,
			actions,
			actionWrapperProps,
			...modalProps
		},
		ref,
	) => (
		<Modal open={open} onClose={onClose} ref={ref} {...modalProps}>
			<Stack spacing={2}>
				<Text variant='body1' text={title} />
				<Text variant='body2' color='text.secondary' text={subtitle} />

				<Footer
					onClose={onClose}
					onConfirm={onConfirm}
					confirmText={confirmText}
					cancelText={cancelText}
					actions={actions}
					actionWrapperProps={actionWrapperProps}
				/>
			</Stack>
		</Modal>
	),
)
